<template>
  <div>
    <div class="d-flex align-center justify-center">
      <div class="heading-4 font-weight-medium">Migrate</div>
      <v-divider class="mx-6 border-vaults" vertical></v-divider>
      <div
        class="text-7 font-weight-medium px-2 py-1 rounded-5 black--text-abs bg-vaults"
      >
        DEFI VAULTS
      </div>
      <v-divider class="mx-6 border-vaults" vertical></v-divider>
      <img
        src="@/assets/icons/networks/ethereum.svg"
        alt="ethereum"
        height="20"
        width="20"
      />
    </div>
    <div class="d-flex justify-center mt-16 p-relative">
      <div class="migrate-box pa-10">
        <div class="d-flex justify-center">
          <div
            :class="[
              'text-4 font-weight-medium',
              { 'gray--text clickable': step > 1 },
            ]"
            @click="step = 1"
          >
            1. Withdraw from V2
          </div>
          <div
            :class="[
              'text-4 font-weight-medium ml-16',
              { 'gray--text': step <= 1 },
            ]"
          >
            2. Deposit into V3
          </div>
        </div>
        <v-divider class="border-vault my-10"></v-divider>
        <div class="mt-16">
          <withdraw-step v-if="step === 1" @onNext="step = 2" />
          <deposit-step v-if="step === 2" />
        </div>
      </div>
    </div>
    <c-loading v-if="vaultBalancesState.fetching"></c-loading>
  </div>
</template>

<script>
import WithdrawStep from "./WithdrawStep.vue";
import DepositStep from "./DepositStep.vue";
import { mapGetters } from "vuex";
import BN from "bignumber.js";

export default {
  components: {
    WithdrawStep,
    DepositStep,
  },
  computed: {
    ...mapGetters({
      vaultBalancesState: "vaults/vaultBalances",
    }),
  },
  data: () => ({
    step: 1,
  }),
  watch: {
    ["vaultBalancesState.result"]: {
      immediate: true,
      handler(result) {
        let vaultBalance = null;
        if ((vaultBalance = result?.[this.$route.params.vault])) {
          if (new BN(vaultBalance?.shares).gte(1e-6)) {
            this.step = 2;
          }
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.migrate-box {
  width: 630px;
  height: 690px;
  border: 1px solid #49d999;
  border-radius: 16px;
}
</style>
